module.exports = __webpack_public_path__ + "assets/img/3ba9ad1a753bcb0bcefd39dbd075d682.svg";